// extracted by mini-css-extract-plugin
export const card = "_404-module--card--6uYJI";
export const btn = "_404-module--btn--wr3qx";
export const txt404 = "_404-module--txt404--hCHM+";
export const txtTitle = "_404-module--txtTitle---6ukE";
export const txtDes = "_404-module--txtDes--gyCME";